// @ts-nocheck
import * as React from "react";

const FileFill: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 40">
            <path
                d="M3.53 40h23.529a3.526 3.526 0 003.53-3.516V11.72h-8.236a3.526 3.526 0 01-3.53-3.516V0H3.53A3.526 3.526 0 000 3.516v32.968A3.526 3.526 0 003.53 40zm4.705-23.516h14.118c.65 0 1.176.525 1.176 1.172 0 .648-.526 1.172-1.176 1.172H8.235c-.65 0-1.176-.524-1.176-1.172 0-.647.526-1.172 1.176-1.172zm0 4.688h14.118c.65 0 1.176.524 1.176 1.172 0 .647-.526 1.172-1.176 1.172H8.235c-.65 0-1.176-.525-1.176-1.172 0-.648.526-1.172 1.176-1.172zm0 4.687h14.118c.65 0 1.176.525 1.176 1.172 0 .648-.526 1.172-1.176 1.172H8.235c-.65 0-1.176-.524-1.176-1.172 0-.647.526-1.172 1.176-1.172zm9.412 4.688c.65 0 1.177.524 1.177 1.172 0 .647-.527 1.172-1.177 1.172H8.235c-.65 0-1.176-.525-1.176-1.172 0-.648.526-1.172 1.176-1.172h9.412zM21.177.784l8.627 8.628H22.34a1.164 1.164 0 01-1.164-1.164V.784z"
                fill="currentColor"
                fillRule="nonzero"
            />
        </svg>
    );
};

export default React.memo(FileFill);
